export const iconActions = [
/*  {
    imgFile: `tree.svg`,
    label: `Tree`,
    action: () => {}
  }*/
];
